import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { InformationCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';

export const SearchHelpIconModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const helpItems = [
    {
      title: t('searchbox_help.title_1'),
      desc: t('searchbox_help.desc_1'),
      example: t('searchbox_help.example_1'),
    },
    {
      title: t('searchbox_help.title_2'),
      desc: t('searchbox_help.desc_2'),
      example: t('searchbox_help.example_2'),
    },
    {
      title: t('searchbox_help.title_3'),
      desc: t('searchbox_help.desc_3'),
      example: t('searchbox_help.example_3'),
    },
    {
      title: t('searchbox_help.title_4'),
      desc: t('searchbox_help.desc_4'),
      example: t('searchbox_help.example_4'),
    },
  ];

  return (
    <>
      {/* ヘルプアイコン */}
      <div onClick={() => setIsOpen(true)}>
        <InformationCircleIcon className="size-5 text-gray-500 hover:text-gray-700" />
      </div>

      {/* モーダル */}
      {/* フォーム内ではモーダル開閉イベントが正常に動作しない。createPortalでDOMの最上位にレンダリングすることで問題を回避している。 */}
      {isOpen &&
        createPortal(
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
            onClick={() => setIsOpen(false)}
          >
            <div
              className="relative w-80 rounded-lg bg-white p-4 shadow-xl"
              onClick={(e: React.MouseEvent<HTMLDivElement>) =>
                e.stopPropagation()
              }
            >
              <button
                type="button"
                className="absolute right-4 top-4 text-gray-500 hover:text-gray-700"
                onClick={() => {
                  setIsOpen(false);
                }}
              >
                <XMarkIcon className="size-5" />
              </button>

              <h2 className="mb-4 text-lg font-bold text-gray-900">
                {t('検索のヒント')}
              </h2>

              <ul className="space-y-4 text-sm text-gray-600">
                {helpItems.map((item, index) => (
                  <li key={index} className="space-y-1">
                    <strong>{item.title}</strong>
                    <p className="text-xs">{item.desc}</p>
                    <code className="block rounded bg-gray-100 px-2 py-1 text-xs">
                      {item.example}
                    </code>
                  </li>
                ))}
              </ul>
            </div>
          </div>,
          document.body
        )}
    </>
  );
};
